import React, { Component } from 'react';

class ModalConfirmarBajaAsientos extends Component {

    constructor(props) {
        super(props);
        this.validarAplicarAccionMasiva = this.validarCerrarModal.bind(this);

    }
    validarCerrarModal() {
        const {mostrarOcultarModalAsientosContables, limpiarModalAsientosContables, cambiarValorInput, cambiarInputActivo, validarAplicarAccionMasiva, esModalDetalleAsiento, guardarActualizarAsientoContable, desplegarDatosDetalleAsiento, setearOrigenLlamadoModalConfirmacionBaja, esAccionMasiva} = this.props;

        if(esModalDetalleAsiento) {
            mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", false)
            guardarActualizarAsientoContable("modalAsientosContables")

            desplegarDatosDetalleAsiento(null);
            cambiarValorInput("modalAsientosContables","inputCuentaContable", "");
            cambiarInputActivo("modalAsientosContables", "");
            limpiarModalAsientosContables();

        }else if(esAccionMasiva) {
            mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", false)
            validarAplicarAccionMasiva();
        }

        setearOrigenLlamadoModalConfirmacionBaja("")
    }


    cerrarModal(){
        const {mostrarOcultarModalAsientosContables, esModalDetalleAsiento, esAccionMasiva} = this.props;

        if(esModalDetalleAsiento){
            mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", false)
            mostrarOcultarModalAsientosContables("modalDetalleAsiento", true)
        }else if(esAccionMasiva){
            mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", false)
        }
    }

    render() {
        //ACTIONS
        const {
            mostrarOcultarModalAsientosContables
        } = this.props;

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS AsientosContables__modalConfirmarEliminacionModelosSeleccionados'>
                    <div className='text-right'>
                        <label onClick={() => mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", false)} className='ti-close clickable modalProcesosClose AsientosContables__modalConfirmarEliminacionModelosSeleccionados__botonCerrar'></label>        
                    </div>

                    <div className='modalConfirmarSalirTexto AsientosContables__modalConfirmarEliminacionModelosSeleccionados__mensaje'>
                        ¿Está seguro que desea dar de baja los asientos seleccionados?<br />
                        Una vez realizada esta acción no podrá deshacerse.
                    </div>

                    <div className='modalProcesosFooterShort'>
                        <button onClick={() => this.cerrarModal()} className="btn btn-secondary">Cancelar</button>
                        <button className="btn btn-cta" onClick={() => this.validarCerrarModal()}>Confirmar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalConfirmarBajaAsientos;